import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import type { Epic } from 'Flux/index.js'

export const ClaimOrderEpic: Epic = (action$, state$, { OrderRepository, [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.claimOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.claimOrder(
        action.payload.orderId,
        {
          allowSingletons: action.payload.allowSingletons,
          targetTaxonomy: action.payload.targetTaxa,
          sampleConfiguration: action.payload.sampleConfiguration,
          redlistMode: action.payload.redlistMode
        },
        state.authentication.user,
        action.payload.token
      ).pipe(
        mergeMap((response) => of(order.claimOrderRequestSuccess(response))),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.claimOrderFailure({ error }))
          })
        )
      )
    )
  )
